import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Divider, Link, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import AuthBanner from '../../components/authentication/AuthBanner';

// import useAuth from "../../hooks/useAuth";

import LegalBar from '../../components/layouts/LegalBar';

import { LoginForm } from './components';

const whiteTextColor = '#f4f5f7';

const Login = () => {
  // const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  // const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const smUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  // const xsUp = useMediaQuery((theme) => theme.breakpoints.up("xs"));

  // const isLoginCenter = xsUp || smUp;

  const flexDirection = 'column';
  const minHeightForm = smUp ? '567px' : '520px';
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('AppTitlePrefix')} | Login</title>
      </Helmet>

      <Box
        sx={{
          background: "url('/static/images/bg-login-2.jpg')",
          backgroundPosition: 'center bottom',
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          display: 'flex',
          flexDirection: { flexDirection },
          minHeight: '100vh',
        }}
      >
        {/* sx={{ position: "fixed", top: 0, left: 0 }} */}
        <Box sx={{ maxWidth: '400px' }}>
          <img
            alt="BV Evaluate"
            src="/static/images/iEval_Logo.png"
            style={{ width: '100%' }}
          />
        </Box>

        {/* {smUp && <Box sx={{ flexGrow: 1 }} />} */}
        {smUp && <Box sx={{ flexGrow: 1 }} />}

        <Box
          sx={{
            // marginTop: -25,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {/* {lgUp && <Box sx={{ flexGrow: 5 }} />} */}

          <Container maxWidth="xs" sx={{ minHeight: minHeightForm, mr: 2, mb: 10, mt: 1 }}>
            {/* sx={{ position: "fixed", top: 0, left: 0 }} */}
            {/* <Box>
              <img
                alt="Access BV Logo"
                src="/static/images/AccessBV_Logo.png"
                style={{ width: "100%" }}
              />
            </Box> */}
            <Card
              sx={{
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(21, 21, 21, .6)',
              }}
            >
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  p: 4,
                }}
              >
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    m: -4,
                    mb: 3,
                  }}
                >
                  <Box
                    sx={{
                      background: "url('/static/images/bg-login-form-1.png')",
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      height: 150,
                      width: '100%',
                      opacity: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        height: '100%',
                        p: 1,
                      }}
                    >
                      <img alt="BV Logo" src="/static/images/BVLogoTrans.png" />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    flexGrow: 1,
                    mt: 1,
                  }}
                >
                  <LoginForm />
                </Box>

                <Divider sx={{ my: 3 }} />
                <Link
                  // color="textSecondary"
                    // component={RouterLink}
                  href="https://bureauveritas.onelogin.com/login2"
                  variant="body2"
                  target="_blank"
                  rel="noreferrer"
                  sx={{ color: whiteTextColor }}
                >
                  Forgot password?
                </Link>
              </CardContent>
            </Card>
          </Container>

          {/* {lgUp && <Box sx={{ flexGrow: 1 }} />} */}
        </Box>

        <Box sx={{ flexGrow: 2 }} />
      </Box>

      {smUp && <LegalBar displayLogo displayCopyRight isLogin />}
    </>
  );
};

export default Login;
